import Server from "./index";

export default class TransmedCardServer extends Server {
  constructor() {
    super("/transmed_card.php");
  }

  public get(params?: undefined): Promise<any> {
    return super.get(null);
  }
}
